/// <reference path="../include.ts" />

namespace project_common {

	export enum Lang {
		en = 'en', // don't change
		ja = 'ja', // don't change
		ko = 'ko', // don't change
		th = 'th', // don't change
		zhHans = 'zh-hans', // don't change
		zhHant = 'zh-hant', // don't change
	}
}
